import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useReportCtx } from '../report-ctx';
import { useRegisterReportFormApply } from './useRegisterReportFormApply';

/**
 * Exposes RHF set-field + submit to report context so table filters can update the form.
 */
export function RegisterRhfFormApply() {
  const { setValue, handleSubmit } = useFormContext();
  const { runReport } = useReportCtx();

  const apply = useCallback(
    async (field: string, value: unknown) => {
      setValue(field, value, { shouldDirty: true, shouldValidate: true });
      await handleSubmit((formValues) => runReport(formValues))();
    },
    [handleSubmit, runReport, setValue],
  );

  useRegisterReportFormApply(apply);

  return null;
}
